module.exports = __webpack_public_path__ + "static/media/husband.132b0fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/husband.jpg
// module id = 363
// module chunks = 0